import FormMaster from '../FormMaster'
import { useTranslation } from 'react-i18next'

const ProductGroup = () => {
  const { t } = useTranslation(['product-group', 'common'])
  return <FormMaster
    title={t('product_group_information')}
    tableConfig={{
      key: "id",
      apiPath: "prodgroup/list",
      allowDelete: {
        visible: true,
        key: "group_id",
        apiPath: "prodgroup/delete"
      },
      optionDeleteFag: true,
      defaultColumn: [],
      columns: [
        {
          dataField: 'no',
          caption: t('no'),
          width: 60,
          alignment: "center",
          allowFiltering: false
        },
        {
          dataField: 'group_name',
          caption: t('product_group_name'),
          allowFiltering: true
        },
        {
          dataField: 'description',
          caption: t('description'),
        },
        {
          dataField: 'updated_by',
          caption: t('edited_by'),
        }
      ],
      exportExcel: {
        fileName: t('product_group_information'),
        columnConfig: [
          { label: t('no'), value: 'no' },
          { label: t('product_group_name'), value: 'group_name' },
          { label: t('description'), value: 'description' },
          { label: t('edited_by'), value: 'updated_by' }
        ]
      }
    }}
    formData={{
      group_name: "",
      description: ""
    }}
    modalConfig={{
      visible: true,
      title: t('product_group_information'),
      required: ["group_name"],
      fieldTypeNumber: [],
      paramName: "group_id",
      apiPath: {
        "get": '',
        "post": 'prodgroup/add',
        "put": 'prodgroup/update'
      },
      elements: [
        {
          fieldName: "group_name",
          label: t('product_group_name'),
          placeholder: t('product_group_name'),
          required: true,
          inputType: "text",
          isOneRow: true
        },
        {
          fieldName: "description",
          label: t('description'),
          placeholder: t('description'),
          inputType: "text",
          isOneRow: true
        }
      ]
    }}
  />
}

export default ProductGroup